import Data from "../../Assets/data-jardim.json";
import DataMod1f1 from "../../Assets/modosFases/ConstrutorMod1_1.json";
import DataMod1f2 from "../../Assets/modosFases/ConstrutorMod1_2.json";
import DataMod1f3 from "../../Assets/modosFases/ConstrutorMod1_3.json";

import DataMod2f1 from "../../Assets/modosFases/ConstrutorMod2_1.json";
import DataMod2f2 from "../../Assets/modosFases/ConstrutorMod2_2.json";
import DataMod2f3 from "../../Assets/modosFases/ConstrutorMod2_3.json";

import DataMod3f1 from "../../Assets/modosFases/ConstrutorMod3_1.json";
import DataMod3f2 from "../../Assets/modosFases/ConstrutorMod3_2.json";
import DataMod3f3 from "../../Assets/modosFases/ConstrutorMod3_3.json";

export default class Construtor {
  constructor(level) {
    this.level = level;
    // Porpriedades do tabuleiro
    this.colunas = level.getLargura();
    this.linhas = level.getAltura();
    this.quantPalavras = level.getQuantidadePalavras();

    //Intermediarios
    // Resultado: Conteudo, gabarito e controle do game
    this.tabuleiro = {
      indice: Array(),
      posicoes: Array(),
      palavras: Array(),
      ref: Array(),
      gabarito: Array(this.colunas * this.linhas).fill(0),
      vinculo: Array(this.colunas * this.linhas).fill(Array(1).fill(null)),
    };
    this.indexPalavra = 0;
    // Variaveis
    this.tentativas = this.vetorPosibilidades();
    this.count = 0;
    this.percorrertentativas = 0;
    this.ancoras = [];
    this.dataNivel = [];
    this.indiceteste = [];
    this.separaNiveis(level.modo);

    // Calibre
    this.teste = [13, 34, 121];
    this.calibre_soltasIniciais = 2;
    this.calibre_centroides = {
      0: Array(),
      1: Array(),
      2: Array(),
    };
    this.percorrerPalavras = 0;

    // RESULTADO
    this.principal = Array();

    //Configurando
    this.init();
  }

  forcebruta(quantPalavras){

    // Exemplo de inserção manual das palavras

    

    var palavra, posicao
    console.log(Data);

    // Modo 1 Fase 1 --------------------
    // this.indexPalavra = 1
    // posicao = 15
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 7
    // posicao = 24
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 5
    // posicao = 98
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 5
    // posicao = 98
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 3
    // posicao = 54
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 0
    // posicao = 8
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 2
    // posicao = 125
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);
    // Modo 1 - Fase 2---------------------------
    // this.indexPalavra = 2
    // posicao = 38
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 6
    // posicao = 2
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 7
    // posicao = 29
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 9
    // posicao = 64
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 4
    // posicao = 42
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 3
    // posicao = 113
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 1
    // posicao = 1
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 5
    // posicao = 120
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // Modo 1 - Fase 3---------------------------

    

    // this.indexPalavra = 6
    // posicao = 69
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 4
    // posicao = 72
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 5
    // posicao = 13
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // // this.indexPalavra = 0
    // // posicao = 48
    // // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // // console.log(palavra);
    // // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 3
    // posicao = 24
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 2
    // posicao = 18
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 1
    // posicao = 10
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 8
    // posicao = 108
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 9
    // posicao = 123
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);
    
    // Modo 2 - Fase 1---------------------------

    // this.indexPalavra = 0
    // posicao = 96
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 6
    // posicao = 41
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 8
    // posicao = 56
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 3
    // posicao = 13
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 5
    // posicao = 15
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 4
    // posicao = 49
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // Modo 2 - Fase 2---------------------------

    // this.indexPalavra = 0
    // posicao = 25
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 1
    // posicao = 49
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 2
    // posicao = 16
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 3
    // posicao = 57
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 4
    // posicao = 2
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 6
    // posicao = 108
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 8
    // posicao = 11
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 9
    // posicao = 100
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // Modo 2 - Fase 3---------------------------

    // this.indexPalavra = 8
    // posicao = 81
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 3
    // posicao = 72
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 1
    // posicao = 100
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 2
    // posicao = 1
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 7
    // posicao = 108
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 5
    // posicao = 64
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 4
    // posicao = 27
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 9
    // posicao = 7
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 6
    // posicao = 134
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // Modo 3 - Fase 1---------------------------

    // this.indexPalavra = 0
    // posicao = 4
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 1
    // posicao = 39
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 2
    // posicao = 42
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 3
    // posicao = 75
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 6
    // posicao = 101
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 7
    // posicao = 12
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);
    
    // Modo 3 - Fase 2---------------------------

    // this.indexPalavra = 0
    // posicao = 24
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 3
    // posicao = 60
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 8
    // posicao = 96
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 2
    // posicao = 29
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 1
    // posicao = 0
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // // this.indexPalavra = 7
    // // posicao = 132
    // // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // // console.log(palavra);
    // // this.setPosicao(palavra, 0 , posicao);

    // // this.indexPalavra = 8
    // // posicao = 35
    // // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // // console.log(palavra);
    // // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 9
    // posicao = 3
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 4
    // posicao = 7
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);
    
    // Modo 3 - Fase 3---------------------------


    

    // this.indexPalavra = 9
    // posicao = 0
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);


    // this.indexPalavra = 0
    // posicao = 37
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

   

    // this.indexPalavra = 1
    // posicao = 73
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);


    // this.indexPalavra = 3
    // posicao = 64
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 7
    // posicao =109
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 5
    // posicao = 66
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 2
    // posicao = 44
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);

    // this.indexPalavra = 4
    // posicao = 135
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 0 , posicao);

    // this.indexPalavra = 8
    // posicao = 11
    // palavra = this.dataNivel[this.indexPalavra]["Resposta"]
    // console.log(palavra);
    // this.setPosicao(palavra, 1 , posicao);
    
    this.level.setQuantidadePalavras(this.count);
    return this.tabuleiro.gabarito;

  }

  init() {

    // // this.tabuleiro.gabarito = this.geradorGabarito(this.quantPalavras);
    // this.tabuleiro.gabarito = this.forcebruta(this.quantPalavras);


    //   // Unificando informações para teclado
    //   let obj = {};
    //   for (let index = 0; index < this.principal.length; index++) {
    //     obj = this.principal[index];
    //     obj["letras"] = this.tabuleiro.palavras[index].split("");
    //     obj["teclas"] = this.teclas(obj["letras"]);
    //     obj["posicao"] = this.tabuleiro.posicoes[index];
    //     obj["ref"] = this.tabuleiro.ref[index];
    //     obj = {};
    //   }

    //   // Unificando informações para o tabuleiro - Vinculo
    //   let element = [];
    //   for (let palavra = 0; palavra < this.tabuleiro.posicoes.length; palavra++)
    //     for (
    //       let index = 0;
    //       index < this.tabuleiro.posicoes[palavra].length;
    //       index++
    //     ) {
    //       if (
    //         this.tabuleiro.vinculo[this.tabuleiro.posicoes[palavra][index]][0] !==
    //         null
    //       ) {
    //         element = this.tabuleiro.vinculo[
    //           this.tabuleiro.posicoes[palavra][index]
    //         ].slice();
    //         element.push(palavra);
    //         this.tabuleiro.vinculo[
    //           this.tabuleiro.posicoes[palavra][index]
    //         ] = element.slice();
    //       } else {
    //         element.push(palavra);
    //         this.tabuleiro.vinculo[
    //           this.tabuleiro.posicoes[palavra][index]
    //         ] = element.slice();
    //       }
    //       element = [];
    //     }
    //     this.quantPalavras = this.principal.length;


    let dataSegura;

    switch (this.level.modo) {
      case "CURIOSIDADE":
        switch (this.level.getFase()) {
          case 1:
            dataSegura = DataMod1f1;
            break;
          case 2:
            dataSegura = DataMod1f2;
            break;
          case 3:
            dataSegura = DataMod1f3;
            break;
    
          default:
            break;
        }
        break;
      case "USO":
        switch (this.level.getFase()) {
          case 1:
            dataSegura = DataMod2f1;
            break;
          case 2:
            dataSegura = DataMod2f2;
            break;
          case 3:
            dataSegura = DataMod2f3;
            break;
    
          default:
            break;
        }
        break;
      case "POPULAR":
        switch (this.level.getFase()) {
          case 1:
            dataSegura = DataMod3f1;
            break;
          case 2:
            dataSegura = DataMod3f2;
            break;
          case 3:
            dataSegura = DataMod3f3;
            break;
    
          default:
            break;
        }
        break;

      default:
        break;
    }

    

    // Instanciando alternativa

    this.colunas = dataSegura.colunas;
    this.linhas = dataSegura.linhas;
    this.quantPalavras = dataSegura.principal.length;

    this.tabuleiro = dataSegura.tabuleiro;
    this.principal = dataSegura.principal;
  }

  /**
   * @description gerador de teclas
   * @returns {Array}Letras aleatórias para as teclas do tabuleiro.
   */

  teclas(palavra) {
    var alfabeto = [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];
    var conteudo = Array(this.level.getquantidadesTeclas()).fill(null);
    let posi = 0;
    palavra.forEach((element) => {
      posi = Math.floor(Math.random() * (conteudo.length - 1));
      if (conteudo.length <= posi || 0 > posi) console.log("ERRRRRRO");
      while (conteudo[posi]) {
        if (posi < conteudo.length - 1) posi++;
        else posi = 0;
      }
      conteudo[posi] = element;
      if (conteudo.length > 12) console.log(conteudo);
    });


    conteudo = conteudo.map((element) => {
      if (!element)
        return alfabeto[Math.floor(Math.random() * alfabeto.length)];
      else return element;
    });

    if (conteudo.length > 12)
      console.log("ESTOUROU -------------------------------");

    return conteudo;
  }

  inserirPalavra(inicialposicao, finalposicao, palavra, rot) {
    var referencia = Array();

    // eslint-disable-next-line default-case
    switch (rot) {
      case 0:
        //horizontal

        for (
          let index = inicialposicao, inpalavras = 0;
          index < finalposicao;
          index++, inpalavras++
        ) {
          this.tabuleiro.gabarito[index] = palavra[inpalavras];
          referencia.push(index);
        }

        // Teste - inicio e fim
        // for (let index = 0; index < 4; index++)
        //     if (index !== 1)
        this.ajusteMarcaCruzamento(inicialposicao, 3);

        // for (let index = 0; index < 4; index++)
        //     if (index !== 3)
        this.ajusteMarcaCruzamento(finalposicao - 1, 1);

        this.tabuleiro.ref.push(this.count);
        this.count += 1;
        this.tabuleiro.posicoes.push(referencia);
        this.tabuleiro.palavras.push(palavra);
        this.principal.push(this.dataNivel[this.indexPalavra]);
        this.ancoras.push(rot);
        this.tabuleiro.indice.push(referencia[0])

        break;

      case 1:
        //vertical

        for (
          let index = inicialposicao, inpalavras = 0;
          index <= finalposicao;
          index += this.colunas, inpalavras++
        ) {
          this.tabuleiro.gabarito[index] = palavra[inpalavras];
          referencia.push(index);
        }

        // Teste - inicio e fim
        // for (let index = 0; index < 4; index++)
        //     if (index !== 2)
        this.ajusteMarcaCruzamento(inicialposicao, 0);

        // for (let index = 0; index < 4; index++)
        //     if (index !== 0)
        this.ajusteMarcaCruzamento(finalposicao - this.colunas, 2);

        this.tabuleiro.ref.push(this.count);
        this.count += 1;
        this.tabuleiro.posicoes.push(referencia);
        this.tabuleiro.palavras.push(palavra);
        this.principal.push(this.dataNivel[this.indexPalavra]);
        this.ancoras.push(rot);
        this.tabuleiro.indice.push(referencia[0])
        break;
    }
  }

  /**
   * @description Testa e posiciona as palavras no tabuleiro
   * @param {Number} rot Indica a rotação, ou seja, orientação das palavras.<br>
   * Sendo elas 0, 1, 2 e 3, respectivamente, horizontal, vertical, diagonal (cima para baixo) e diagonal (baixo para cima).
   * @param {Array} possibilidade Indica possibilidade gerado e mantido em vetor por @module vetorPosibilidades, percorrido pelo método altamente acoplado @method geradorGabarito.
   * @param {String} palavra Indica a palavras coletados do import @module Data e percorrida pelo método
   * altamente acoplada @method geradorGabarito
   * @returns {boolean} Indicando o sucesso ou fracasso, respectivamente, não posicionou ou posicinou
   * no posicionamento.
   */
   testOcupa(rot, possibilidade, palavra) {
    var finalposicao;
    var inicialposicao = possibilidade;
    switch (rot) {
      case 0:
        //horizontal
        finalposicao = palavra.length + possibilidade;
        //Teste - Comprimento total
        if (finalposicao > this.colunas * this.linhas) return true;

        //Teste - Desocupado
        for (let index = inicialposicao; index < finalposicao; index++) {
          // if (this.tabuleiro.gabarito[index] === -1)
          //     if(this.tabuleiro.gabarito[index-this.colunas] )
          if (
            this.tabuleiro.gabarito[index] !== 0 &&
            this.tabuleiro.gabarito[index] !== palavra[index - possibilidade]
          )
            return true;
        }


        // Teste - inicio e fim
        // dir => direção de analise
        // dir = 0 - cima
        // dir = 1 - direita
        // dir = 2 - baixo
        // dir = 3 - esquerda
        for (let index = 0; index < 4; index++) {
          if (index === 3)
            if (this.ajusteCruzamento(inicialposicao, index)) return true;
        }

        for (let index = 0; index < 4; index++) {
          if (index === 1)
            if (this.ajusteCruzamento(finalposicao-1, index)) return true;
        }


        this.inserirPalavra(inicialposicao, finalposicao, palavra, rot);

        return false;

      case 1:
        //vertical
        finalposicao = ((palavra.length -1) * this.colunas) + possibilidade;
        if (finalposicao > this.colunas * this.linhas) return true;
        for (
          let index = inicialposicao, inpalavras = 0;
          index < finalposicao;
          index += this.colunas, inpalavras++
        ) {
          if (
            this.tabuleiro.gabarito[index] !== 0 &&
            this.tabuleiro.gabarito[index] !== palavra[inpalavras]
          )
            return true;
        }

        // Teste - inicio e fim
        // dir => direção de analise
        // dir = 0 - cima
        // dir = 1 - direita
        // dir = 2 - baixo
        // dir = 3 - esquerda
        for (let index = 0; index < 4; index++) {
          if (index === 0)
            if (this.ajusteCruzamento(inicialposicao, index)) return true;
        }

        for (let index = 0; index < 4; index++) {
          if (index === 2)
            if (this.ajusteCruzamento(finalposicao, index)) return true;
        }

        this.inserirPalavra(inicialposicao, finalposicao, palavra, rot);

        return false;

      default:
    }

    //Manter o loop
    return true;
  }

  ajusteMarcaCruzamento(posicao, dir) {
    // dir => direção de analise
    // dir = 0 - cima
    // dir = 1 - direita
    // dir = 2 - baixo
    // dir = 3 - esquerda
    var analise = 0;

    //RETIRANDO dir
    // dir = 5

    switch (dir) {
      case 0:
        // // inicio cima
        analise = posicao - this.linhas;
        if (
          Math.trunc(posicao / this.linhas) !== 0 &&
          this.tabuleiro.gabarito[analise] === 0
        ) {
          this.tabuleiro.gabarito[analise] = -1;
        }
        break;

      case 1:
        // inicio direita
        analise = posicao + 1;
        if (
          posicao % this.linhas !== this.colunas - 1 &&
          this.tabuleiro.gabarito[analise] === 0
        ) {
          this.tabuleiro.gabarito[analise] = -1;
        }

        break;

      case 2:
        // // inicio baixo
        analise = posicao + this.linhas;
        if (
          Math.trunc(posicao / this.linhas) !== this.linhas - 1 &&
          this.tabuleiro.gabarito[analise] === 0
        ) {
          this.tabuleiro.gabarito[analise] = -1;
        }
        break;

      case 3:
        // // inicio esquerda
        analise = posicao - 1;
        if (
          posicao % this.linhas !== 0 &&
          this.tabuleiro.gabarito[analise] === 0
        ) {
          this.tabuleiro.gabarito[analise] = -1;
        }

        break;

      default:
        break;
    }
  }

  ajusteCruzamento(posicao, dir) {
    // dir => direção de analise
    // dir = 0 - cima
    // dir = 1 - direita
    // dir = 2 - baixo
    // dir = 3 - esquerda
    let analise = 0;

    switch (dir) {
      case 0:
        // // inicio cima
        analise = posicao - this.linhas;
        if (this.tabuleiro.gabarito.length > analise && analise >= 0)
          if (this.tabuleiro.gabarito[analise] !== 0) return true;

        return false;
        break;

      case 1:
        // inicio direita

        analise = posicao + 1;
        if (this.tabuleiro.gabarito.length > analise && analise >= 0)
          if (
            posicao % this.linhas !== this.colunas - 1 &&
            this.tabuleiro.gabarito[analise] !== 0
          )
            return true;

        return false;
        break;

      case 2:
        // // inicio baixo
        analise = posicao + this.linhas;
        if (this.tabuleiro.gabarito.length > analise && analise >= 0)
          if (this.tabuleiro.gabarito[analise] !== 0) return true;

        return false;
        break;

      case 3:
        // // inicio esquerda

        analise = posicao - 1;
        if (this.tabuleiro.gabarito.length > analise && analise >= 0)
          if (
            posicao % this.linhas !== 0 &&
            this.tabuleiro.gabarito[analise] !== 0
          )
            return true;

        return false;
        break;

      default:
        return false;
        break;
    }
  }

  /**
   * @description Pré-teste de posicionamento de palavras considerando os parâmetros até os limites do tabuleiro
   * @param {Number} rot  Indica a rotação, ou seja, orientação das palavras.<br>
   * Sendo elas 0, 1, 2 e 3, respectivamente, horizontal, vertical, diagonal (cima para baixo) e
   * diagonal (baixo para cima).
   * @param {Array} possibilidade Indica possibilidade gerado e mantido em vetor por @method vetorPosibilidades,
   * percorrido pelo método altamente acoplado @method geradorGabarito.
   * @param {String} palavra Indica a palavras coletado do import @module Data e percorrida pelo
   * método altamente acoplada @method geradorGabarito
   * @returns {boolean} Cascata do @returns {boolean} do @method testOcupa.
   */
   setPosicao(palavra, rot, possibilidade) {
    var xespaco;
    var yespaco;
    switch (rot) {
      case 0:
        //horizontal
        xespaco = this.colunas - (possibilidade % this.colunas);
        if (palavra.length <= xespaco) {
          return this.testOcupa(rot, possibilidade, palavra);
        }
        break;
      case 1:
        //vertical
        
        yespaco = this.linhas - Math.round(possibilidade / this.colunas)+1;
        if (palavra.length <= yespaco) {
          return this.testOcupa(rot, possibilidade, palavra);
        }
        break;

      default:
    }
    //Manter o loop

    return true;
  }

  posicaoSolta(naoinserido, rot) {
    var palavra;
    var possibilidade = 0;

    var limite = 5000;
    var i = 0;

    // Percorrer palavras ja posicionadas
    var rotpercorrer = this.ancoras[this.count - 1] === 0 ? 1 : 0;

    this.percorrertentativas =
      this.percorrertentativas >= this.tentativas.length
        ? 0
        : this.percorrertentativas;

    // Criação de centroides

    if (this.count <= this.calibre_soltasIniciais) {
      this.calibre_centroides[this.count].push(this.count);
    }


    // palavra = this.selecionarPalavras(rotpercorrer);
    // do {
    //   if (naoinserido) {

    //     possibilidade = this.tentativas[this.percorrertentativas];

    //     naoinserido = this.setPosicao(palavra, rotpercorrer, possibilidade);
    //   }

    //   this.percorrertentativas++
    //   i++
    // } while (naoinserido  && i < limite);

    do {
      palavra = this.selecionarPalavras(rotpercorrer);
      if (naoinserido) {
        possibilidade = this.teste[this.percorrertentativas];
        naoinserido = this.setPosicao(palavra, rotpercorrer, possibilidade);
      }

      i++;
    } while (naoinserido && i < limite);
    this.percorrertentativas++;

    return naoinserido;
  }

  centroide_percorrer(icentroides) {
    let flag = this.calibre_soltasIniciais;
    while (flag > 0) {
      icentroides--;
      icentroides = icentroides < 0 ? this.calibre_soltasIniciais : icentroides;

      if (this.calibre_centroides[icentroides].length !== 0) return icentroides;
    }

    return -1;
  }

  centroide_modelo() {
    return JSON.parse(JSON.stringify(this.calibre_centroides));
  }

  centroide_maior() {
    let min = 1000;
    let i;
    //Selecionando o maior centroide
    for (let index = 0; index <= this.calibre_soltasIniciais; index++)
      if (min >= this.calibre_centroides[index].length) {
        i = index;
        min = this.calibre_centroides[index].length;
      }

    return i;
  }

  inserir_forceProbabilidade(palavra, rotpercorrer, refancora) {
    //Armazenando as palavras
    var tentativasCruz = Array();
    var possibilidade = 0;
    var corrercruz = 0;
    let naoinserido = true;

    tentativasCruz = this.forceProbabilidade(palavra, rotpercorrer, refancora);
    corrercruz = 0;

    while (naoinserido && corrercruz < tentativasCruz.length) {
      possibilidade = tentativasCruz[corrercruz];
      naoinserido = this.setPosicao(palavra, rotpercorrer, possibilidade);
      corrercruz++;
    }

    return naoinserido;
  }

  posicaoAncora(naoinserido) {

    // Percorrer palavras ja posicionadas
    var palavra;
    var rotpercorrer = 0;

    //Controle de iterações
    var limite = 100;
    var i = 0;

    //Centroide
    let centroides;
    let refancora = 0; // da centroide
    let icentroides;

    if (naoinserido) {
      //iniciando com a maior Centroide

      do {
        // Centroide
        centroides = this.centroide_modelo();
        icentroides = this.centroide_maior();

        do {
          // Obtendo palavra do centroide
          refancora = centroides[icentroides].pop();
          rotpercorrer = this.ancoras[refancora] === 0 ? 1 : 0;
          palavra = this.selecionarPalavras(rotpercorrer);
          // Com o centroide seleciodo tenta posicionar as palavras
          naoinserido = this.inserir_forceProbabilidade(
            palavra,
            rotpercorrer,
            refancora
          );

          // Armazena no principal se rolar
          if (!naoinserido) {
            this.calibre_centroides[icentroides].push(this.count - 1);
          }
          // Consumindo

          icentroides = this.centroide_percorrer(icentroides);
        } while (icentroides > 0 && naoinserido);
        i++;
      } while (icentroides >= 0 && naoinserido && limite > i);
    }

    return naoinserido;
  }

  /**
   * @description Centralizado pelos métodos @method setPosicao e @method testOcupa,
   * e deve se manter juntas e acopladas
   * @returns {Array} Retorno o gabarito onde cada celula é preenchida com as letras ou nula.
   */
  geradorGabarito(quantPalavras) {
    var rot = 0;
    var naoinserido = true;

    var limite = 1;
    var i = 0;

    for (let index = 0; index < quantPalavras; index++) {
      if (this.count <= this.calibre_soltasIniciais)
        naoinserido = this.posicaoSolta(naoinserido, rot);
      while (naoinserido && limite > i) {
        if (this.count > this.calibre_soltasIniciais)
          naoinserido = this.posicaoAncora(naoinserido, rot);
        i++;
      }

      if (rot >= 1) rot = 0;
      else rot++;
      naoinserido = true;
      i = 0;
    }
    this.level.setQuantidadePalavras(this.count);

    return this.tabuleiro.gabarito;
  }

  forceProbabilidade(atual, rot, ancora) {

    let palavratual = atual.split("");

    let palavranterior = this.tabuleiro.palavras[ancora].split("");
    let posicoes = [];
    let posicoesindex = [];

    for (let index = 0; index < palavratual.length; index++) {
      for (let ref = 0; ref < palavranterior.length; ref++) {
        if (
          palavranterior[ref] === palavratual[index]
          //&& !posicoes.includes(this.tabuleiro.posicoes[ancora][ref])
        ) {
          posicoes.push(this.tabuleiro.posicoes[ancora][ref]); // posições de intersecção
          posicoesindex.push(index); //Deslocamento palavra atual
          //ref = palavranterior.length;
        }
      }
    }
    switch (rot) {
      case 0:
        for (let index = 0; index < posicoes.length; index++) {
          posicoes[index] = posicoes[index] - posicoesindex[index];
        }

        break;

      case 1:
        for (let index = 0; index < posicoes.length; index++) {
          posicoes[index] =
            posicoes[index] - posicoesindex[index] * this.colunas;
        }

        break;

      default:
        break;
    }

    posicoes = this.randomArray(posicoes);
    return posicoes;
  }

  /**
   * @description Método gerador do vertor de possibilidade, ou seja,
   *  representa a possiveis posições das palavras tomando como referencia a primeira letra.
   * @returns {Array} Retorna o vetor de possibilidades.
   */
  vetorPosibilidades() {
    var tam = this.colunas * this.linhas;
    var posicoes = Array(tam);
    let desl = 11;

    //abordagem aleatória
    let aux = 0,
      ind1,
      ind2;
    // for (let i = 0; i < tam; i++)
    //   posicoes[i] = i;
    // posicoes = this.randomArray(posicoes)
    // posicoes[0] = tam/2 - 12

    //abordagem fixa , focado no meio
    for (let i = 0; i < tam / 2 - desl; i++)
      posicoes[i] = tam / 2 - desl - i - 1;
    for (let i = tam / 2 - desl; i < tam; i++) posicoes[i] = i;

    return posicoes;
  }

  randomArray(arrayOrin) {
    let tam = arrayOrin.length;
    let lista = arrayOrin.slice();
    let aux = 0,
      ind1,
      ind2;
    for (let i = 0; i < tam; i++) {
      ind1 = Math.floor(Math.random() * tam);
      ind2 = Math.floor(Math.random() * tam);
      aux = lista[ind1];
      lista[ind1] = lista[ind2];
      lista[ind2] = aux;
    }
    return lista;
  }

  /**
   * @description Método para selecionar uma palavra ao acaso.
   * @returns {String} Retorna uma palavra aleatória.
   */
  selecionarPalavras(rot) {
    var palavra;
    var MAX;
    switch (rot) {
      case 0:
        MAX = this.colunas;
        break;
      case 1:
        MAX = this.linhas;
        break;
      default:
    }

    var len = MAX + 1;
    var flagRep = true;

    let teste;
    while (!(len < MAX && flagRep)) {
      teste = Math.random() * this.dataNivel.length;
      this.indexPalavra = Math.floor(teste);

      palavra = this.dataNivel[this.indexPalavra]["Resposta"];
      len = palavra.length;
      if (this.tabuleiro.palavras.includes(palavra)) flagRep = false;
      else flagRep = true;
    }
    return palavra;
  }

  /**
   * @description Método necessário para preencher o conteúdo das células com letras aleatórias.
   * @returns {Array} Retorna o vetor com o conteúdo das células preenchidas com letras aleatórias com as palavras selecionadas e posicionadas.
   */
  geradorChar(value) {
    var alfabeto = [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];
    var conteudo = Array(value);
    for (let index = 0; index < value; index++) {
      conteudo[index] = alfabeto[Math.floor(Math.random() * alfabeto.length)];
      //conteudo[index] = ".";
    }

    for (let index = 0; index < value; index++) {
      if (this.tabuleiro.gabarito[index] !== 0)
        conteudo[index] = this.tabuleiro.gabarito[index];
    }
    return conteudo;
  }
  

  separaNiveis(nivel) {
    this.dataNivel = Data.filter((item) => {
      if (item.Tipo === nivel) return item;
    });
    this.dataNivel = this.dataNivel.filter((item) => {
      if (item.Nivel === this.level.getFase()) return item;
    });
    // this.dataNivel = Data
  }
}
